import mixpanel from "mixpanel-browser";

const ENV_CHECK = process.env.NODE_ENV === "production" && process.env.REACT_APP_MIXPANEL_TOKEN;
const MIXPANEL_PROXY = "https://monitor.tinuiti.com";

if (ENV_CHECK) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    api_host: MIXPANEL_PROXY,
  });
}

// this keeps us from accidentally creating similar events
export const enum MxE {
  PAGE_KPI_CHANGE = "page_kpi_change",
  EXCEL_DOWNLOAD = "excel_download",
  PNG_DOWNLOAD = "png_download",
  DATE_GROUPING_CHANGE = "date_grouping_change",
  METRIC_OPTION_CHANGE = "metric_option_change",
  LOG_SCALE_CHANGE = "log_scale_change",
  WIDGET_PRESET_CHANGE = "widget_preset_change",
  GRAPH_OR_TABLE_CHANGE = "graph_or_table_change",
  SOT_VS_PLATFORM_CHANGE = "sot_vs_platform_change",
  PAGE_PRESET_CHANGE = "page_preset_chage",
  DATE_CHANGE = "date_change",
  CSV_DOWNLOAD = "csv_download",
  REFRESH_CC_VIEWS = "refresh_cross_channel_views",
  HOWTO_VIDEO_STARTED = "howto_video_started",
  HOWTO_VIDEO_COMPLETED = "howto_video_completed",
  FLOATING_PANEL_OPEN_SIDEPANEL = "floating_panel_open_sidepanel",
  FLOATING_PANEL_CLOSE_SIDEPANEL = "floating_panel_close_sidepnel",
  FLOATING_PANEL_EXPAND = "floating_panel_expand",
  FLOATING_PANEL_MINIMIZE = "floating_panel_minimize",
  FLOATING_PANEL_RESET = "floating_panel_reset",
  FLOATING_PANEL_DRAG_REPOSITION = "floating_panel_drag_reposition",
  FLOATING_PANEL_DRAG_RESIZE = "floating_panel_drag_resize",
  LLM_COPY_MESSAGE = "llm_copy_message",
  LLM_SESSION_STATE_MANAGEMENT = "llm_session_state_management",
  NAVBAR_TOP_CLICK = "navbar_top_click",
  NAVBAR_SUB_CLICK = "navbar_sub_click",
  NAVBAR_SEARCH_RESULT_CLICK = "navbar_search_result_click",
  SLIDE_GENERATOR_GENERATE_PRESENTATION = "slide_generator_generate_presentation",
  SLIDE_GENERATOR_SAVE_EDITS = "slide_generator_save_edits",
  SLIDE_GENERATOR_SAVE_AS_NEW_TEMPLATE = "slide_generator_save_as_new_template",
  WEB_VITAL = "web_vital",
  PAGE_DATA_LOAD = "page_data_load",
  LAMBDA_FETCH_FAILED = "lambda_fetch_failed",
  // add new events types here
}

type LLMSessionStateManagementType = "Pin" | "Archive" | "Unpin" | "Unarchive" | "Rename";
interface MixpanelEventProps {
  widget?: string;
  option_selected?: string | number | boolean;
  primary_or_comparison?: "primary" | "comparison" | "both";
  fileName?: string;
  label?: string;
  messageId?: string;
  type?: LLMSessionStateManagementType;
  navbarTarget?: string;
  navbarSearchQuery?: string;
  metric_name?: string;
  metric_value?: number;
  rating?: string;
  page?: string;
  // lambda_fetch_failed telemetry
  service?: string;
  endpoint?: string;
  method?: string;
  error_type?: string;
  error_message?: string;
  status?: number;
  attempts?: number;
  hours_alive?: number;
  online?: boolean;
  visibility?: string;
  connection?: string;
  paused_for_visibility?: boolean;
  // add new event property types here
}

interface MixpanelRegisterProps {
  company?: any | null;
  active_page?: string | null;
  page_group?: string | null;
  // add new register properties types here
}

export const Mixpanel = {
  identify: (id: string): void => {
    if (ENV_CHECK) {
      mixpanel.identify(id);
    }
  },
  track: (name: MxE, props?: MixpanelEventProps): void => {
    if (ENV_CHECK) {
      mixpanel.track(name, props);
    }
  },
  track_pageview: (props: Record<string, any>): void => {
    if (ENV_CHECK) {
      mixpanel.track_pageview(props);
    }
  },
  people: {
    set: (props: Record<string, any>): void => {
      if (ENV_CHECK) {
        mixpanel.people.set(props);
      }
    },
    set_once: (props: Record<string, any>): void => {
      if (ENV_CHECK) {
        mixpanel.people.set_once(props);
      }
    },
  },
  register: (props: MixpanelRegisterProps): void => {
    if (ENV_CHECK) {
      mixpanel.register(props);
    }
  },
  unregister: (prop: string): void => {
    if (ENV_CHECK) {
      mixpanel.unregister(prop);
    }
  },
  register_once: (props: Record<string, any>): void => {
    if (ENV_CHECK) {
      mixpanel.register_once(props);
    }
  },
};
